const isProduction = import.meta.env.VITE_PROD;

const log = (...args) => {
  if (!isProduction) {
    console.log(...args);
  }
};

const info = (...args) => {
  if (!isProduction) {
    console.info(...args);
  }
};

const warn = (...args) => {
  if (!isProduction) {
    console.warn(...args);
  }
};

const error = (errorObj, contextMessage = '') => {
  if (!isProduction) {
    console.error(contextMessage, errorObj);
  } else {
    console.warn('An error occurred:', contextMessage || (errorObj?.message || String(errorObj)));
  }
};

export const logger = {
  log,
  info,
  warn,
  error,
};
